// EditorErrorBoundary.jsx
// ============================================================================
// Catches render-time crashes in the Editor's panel children (Layers,
// Rooms tab, Picture Frame tool) and shows the actual error text +
// component stack on screen instead of a white page. Wrap each of the
// three panels individually so we can see WHICH one is throwing.
//
// Also logs the full error to the console so remote-debugging tools
// (Safari Web Inspector / Chrome remote debugging) can capture it.
// ============================================================================
import React from 'react';

class EditorErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[EditorErrorBoundary:${this.props.label || 'unknown'}]`, error, info);
    this.setState({ info });
  }

  handleDismiss = () => {
    this.setState({ error: null, info: null });
  };

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.92)',
            color: '#fff',
            fontFamily: 'monospace',
            fontSize: 12,
            padding: 20,
            overflow: 'auto',
            zIndex: 999999,
            lineHeight: 1.5,
          }}
        >
          <div style={{ color: '#ff6b6b', fontWeight: 700, marginBottom: 12, fontSize: 14 }}>
            {this.props.label || 'Panel'} crashed
          </div>
          <div style={{ marginBottom: 12 }}>
            <strong>Message:</strong>
            <div style={{ color: '#ffd166', marginTop: 4 }}>
              {String(this.state.error?.message || this.state.error)}
            </div>
          </div>
          {this.state.error?.stack && (
            <div style={{ marginBottom: 12 }}>
              <strong>Stack:</strong>
              <pre style={{ whiteSpace: 'pre-wrap', color: '#aaa', marginTop: 4 }}>
                {this.state.error.stack}
              </pre>
            </div>
          )}
          {this.state.info?.componentStack && (
            <div style={{ marginBottom: 12 }}>
              <strong>Component stack:</strong>
              <pre style={{ whiteSpace: 'pre-wrap', color: '#aaa', marginTop: 4 }}>
                {this.state.info.componentStack}
              </pre>
            </div>
          )}
          <button
            onClick={this.handleDismiss}
            style={{
              marginTop: 12,
              padding: '8px 16px',
              background: '#4594f9',
              border: 'none',
              color: '#fff',
              borderRadius: 6,
              cursor: 'pointer',
              fontFamily: 'monospace',
            }}
          >
            Dismiss
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default EditorErrorBoundary;